// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .big-icon ion-icon {
  font-size: 64px;
}
:host ion-toolbar {
  --border-color: transparent;
  --background: white;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/global/info-modal/info-modal.page.scss"],"names":[],"mappings":"AACE;EACE,eAAA;AAAJ;AAGE;EACE,2BAAA;EACA,mBAAA;AADJ","sourcesContent":[":host {\n  .big-icon ion-icon {\n    font-size: 64px;\n  }\n\n  ion-toolbar {\n    --border-color: transparent;\n    --background: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
